import Arrow from '@/atoms/Arrow/Arrow'

import { PaginationButtonProps } from './ts'

function PaginationButton({ direction }: PaginationButtonProps) {
  return (
    <button
      className="flex items-center justify-center rounded-full outline-none w-7 h-7 focus:outline-none xl:hover:bg-violet-20"
      type="button"
    >
      <span className="block w-3 h-3 text-violet-200">
        <Arrow direction={direction} />
      </span>
    </button>
  )
}

export default PaginationButton
